export default "__VITE_ASSET__DU5Lhrcm__"